/**
 * Map transport / HTTP failures to user-facing copy.
 * Axios 503 surfaces as "Request failed with status code 503".
 */
export function isServiceUnavailableError(error) {
  const status = error?.response?.status ?? error?.code;
  if (Number(status) === 503) return true;
  const msg = String(error?.message || '');
  return /status code 503/i.test(msg) || /\b503\b/.test(msg);
}

/**
 * @param {unknown} error
 * @param {(key: string, options?: object) => string} t  i18n `t` bound to `errors`
 */
export function friendlyErrorMessage(error, t) {
  if (isServiceUnavailableError(error)) {
    try {
      const msg = t('statusCodeSubHeader.503');
      if (msg && msg !== 'statusCodeSubHeader.503') return msg;
    } catch (_e) {
      // fall through to default copy
    }
    return 'It seems like we are experiencing network or system issues, please check back again in a few minutes';
  }
  return error?.message || String(error || 'Unknown error');
}

export default friendlyErrorMessage;
